import {Base} from "@/api/Base"

export class ChangePassword extends Base {
    //此处修改后台登录用户修改密码的请求路径
    path = "employee/changePassword"
}